import { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { ProductsAnalyticsProvider } from '@client/analytics/context/products/ProductsAnalyticsContext';
import { EVENT_SOURCE } from '@client/analytics/types/types';
import { AppState } from '@client/common/redux/store';
import { isEmpty } from '@client/common/utils/empty/empty';
import { selectProductAccessoriesBySku } from '@client/product/redux/productAccessories/redux';
import { ProductAccessories as Component } from './Component';
import { Props } from './';

export const ProductAccessories = ({ sku }: Props): ReactElement => {
  const accessoriesRecord = useSelector((state: AppState) => selectProductAccessoriesBySku(state, sku));

  if (!accessoriesRecord.isLoaded || isEmpty(accessoriesRecord.data) || !accessoriesRecord.data) {
    return null;
  }

  return (
    <ProductsAnalyticsProvider eventSource={EVENT_SOURCE.accessories}>
      <Component accessories={accessoriesRecord.data} sku={sku} />
    </ProductsAnalyticsProvider>
  );
};
